import { ConfigProvider } from '@portals/sip-client-data/src/general/Config';

export const isIF6Context = (): boolean => {
  const appContext = ConfigProvider.getConfig()?.get('APP_CONTEXT');
  return appContext === 'if6';
};
